import {
    MappedProductCollectionModel,
    type ProductCollectionModel,
} from "../models";

export function constructMappedItem(
    item: ProductCollectionModel,
    parent: MappedProductCollectionModel | undefined = undefined
): MappedProductCollectionModel {
    const newItem = new MappedProductCollectionModel({
        ...item,
        SubCollections: [],
        parent: parent,
    });
    newItem.SubCollections = item.SubCollections.map((sc) =>
        constructMappedItem(sc, newItem)
    );
    return newItem;
}
